module.exports = __webpack_public_path__ + "img/course-apply@2x.5856d7af.png";